import TripSummary from "./TripSummary";

export default TripSummary